module.exports = __webpack_public_path__ + "img/icon-reg-sales-analytics.e361b3a5.png";